import { useEffect } from 'react';

import MainContentPending from '../pageStructure/mainContentPending';

/**
 * Redirects all traffic from /account/iwocapay/ to /pay/account/
 * preserving query parameters.
 */
export function IwocaPayRedirect() {
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        window.location.href = `/pay/account/?${queryParams.toString()}`;
    }, []);

    return <MainContentPending />;
}
